/* global axios */
import ApiClient from './ApiClient';

class AssistantConfigurationsAPI extends ApiClient {
  constructor() {
    super('assistant_configurations', { accountScoped: true });
  }

  workspace(inboxId) {
    return axios.get(this.url, {
      params: inboxId ? { inbox_id: inboxId } : {},
    });
  }

  action(id, action, data) {
    return axios.post(`${this.url}/${id}/${action}`, data);
  }
}
export default new AssistantConfigurationsAPI();
